import LoadingIcon from "components/Loading/LoadingIcon";
import Table from "components/Table/Table";
import { commonColumnProps } from "constants/TableConstants";
import { useState } from "react";
import type { Column } from "react-data-grid";
import type { UserType } from "services/users-api";
import { useGetUsersQuery } from "services/users-api";
import { useToken } from "utils/context";

const OrganizationUsersTable = () => {
  const { accessToken } = useToken();
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const {
    data: usersResponse,
    isLoading: isLoadingUsers,
    error: usersError,
  } = useGetUsersQuery(
    {
      userType: "ORGANIZATION",
      isRejected: false,
      page: currentPage,
      pageSize: pageSize,
    },
    { skip: !accessToken },
  );

  const users = usersResponse?.results || [];
  const totalUsers = usersResponse?.count || 0;

  const columns: Column<UserType>[] = [
    {
      key: "email",
      name: "Email",
      ...commonColumnProps,
    },
    {
      key: "full_name",
      name: "Name",
      ...commonColumnProps,
      renderCell: ({ row }) => {
        return `${row.first_name || ""} ${row.last_name || ""}`.trim() || "-";
      },
    },
    {
      key: "is_active",
      name: "Status",
      ...commonColumnProps,
      width: "10%",
      renderCell: ({ row }) => (
        <div className="flex jc-c">
          {row.is_active ? (
            <span className="material-icons" style={{ color: "green" }}>
              check_circle
            </span>
          ) : (
            <span className="material-icons" style={{ color: "red" }}>
              cancel
            </span>
          )}
        </div>
      ),
    },
  ];

  if (isLoadingUsers) {
    return <LoadingIcon />;
  }

  if (usersError) {
    return <div className="error-message">Error loading users</div>;
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <div className="organization-users-table card">
      <div className="card__header">Organization Users</div>
      <Table
        columns={columns}
        rows={users}
        rowKeyGetter={(row) => row.id}
        emptyTableMessage="No organization users found"
        pagination={{
          pageSize: pageSize,
          pageIndex: currentPage,
          rowCount: totalUsers,
          onPageChange: handlePageChange,
          isLoading: isLoadingUsers,
        }}
        isLoading={isLoadingUsers}
      />
    </div>
  );
};

export default OrganizationUsersTable;
